import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

import { passwordValidateSchema } from './passwordValidateSchema'

export const registerFormSchema = z
  .object({
    firstName: z
      .string()
      .trim()
      .min(1, { message: mxTranslations?.Common?.required_field || 'This is a required field.' })
      .max(255, {
        message:
          mxTranslations?.Common?.input_max_255 || 'Please enter less or equal than 255 symbols.',
      })
      .regex(/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ' -]+$/, {
        message:
          mxTranslations?.Common?.letters_only ||
          'Only letters, spaces, apostrophes and hyphens are allowed',
      }),

    lastName: z
      .string()
      .trim()
      .min(1, { message: mxTranslations?.Common?.required_field || 'This is a required field.' })
      .max(255, {
        message:
          mxTranslations?.Common?.input_max_255 || 'Please enter less or equal than 255 symbols.',
      })
      .regex(/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ' -]+$/, {
        message:
          mxTranslations?.Common?.letters_only ||
          'Only letters, spaces, apostrophes and hyphens are allowed',
      }),

    birthday: z
      .string()
      .refine(
        (val) => {
          if (val.replaceAll('-', '').length < 8) return false
          const date = new Date(val)
          return !isNaN(date.getTime()) // 验证是否是合法的日期
        },
        { message: mxTranslations?.Common?.invalid_date || 'Invalid Date' },
      )
      .refine(
        (val) => {
          const date = new Date(val)
          const today = new Date()
          const age = today.getFullYear() - date.getFullYear()
          const month = today.getMonth() - date.getMonth()
          if (month < 0 || (month === 0 && today.getDate() < date.getDate())) {
            return age - 1 >= 16
          }
          return age >= 16
        },
        {
          message:
            mxTranslations?.Common?.invalid_birthday ||
            'You must be 16 years of age or older to use this site.',
        },
      ),

    email: z
      .string()
      .email({ message: mxTranslations?.Common?.invalid_email_address || 'Invalid email address' }),

    password: passwordValidateSchema
      .pick({ password: true })
      .shape.password.refine((val) => val.trim() !== '', {
        message: mxTranslations?.Common?.invalid_pass || 'Invalid Password',
      }),
    confirmPassword: passwordValidateSchema
      .pick({ password: true })
      .shape.password.refine((val) => val.trim() !== '', {
        message: mxTranslations?.Common?.invalid_pass || 'Invalid Password',
      }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: mxTranslations?.Common?.invalid_pass_confirm || 'Entered passwords differ!',
    path: ['confirmPassword'], // 将错误关联到 confirmPassword 字段
  })

export type TRegisterFormSchema = z.infer<typeof registerFormSchema>
